import { Stepper as MuiStepper, Step, StepLabel, useMediaQuery, useTheme } from "@mui/material";
import { StepIcon } from "../accessible-svg/step-icon/step-icon";
import { useStyles } from "./stepper-style";
import { useTranslation } from "react-i18next";
import { ELEMENT_ID } from "utils/constants";

export interface StepperProps {
  data: any;
  currentStep: string;
}

export const Stepper = ({ data, currentStep }: StepperProps) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const index = Object.keys(data).indexOf(currentStep);
  const noOfSteps = Object.keys(data).length;

  return (
    <MuiStepper alternativeLabel activeStep={index} classes={{ root: classes.stepperContainer }}>
      {Object.values(data).map((label: string, idx) => {
        const stepProps: { completed?: boolean } = {};
        //when it reaches last step(complete page) mark step as completed
        if (index === noOfSteps - 1) {
          stepProps.completed = true;
        }
        return (
          <Step
            key={idx}
            id={`${ELEMENT_ID.STEPPER}-${idx}`}
            classes={{ root: classes.stepAlternativeLabel }}
            {...stepProps}
          >
            <StepLabel
              slots={{ stepIcon: StepIcon }}
              slotProps={{ stepIcon: { title: t(label.toLowerCase()) } }}
            >
              {!isMobile && t(label.toLowerCase())}
            </StepLabel>
          </Step>
        );
      })}
    </MuiStepper>
  );
};
